import script from "./TenantList.vue?vue&type=script&lang=ts&setup=true"
export * from "./TenantList.vue?vue&type=script&lang=ts&setup=true"

import "./TenantList.vue?vue&type=style&index=0&id=11361c52&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11361c52"]])

export default __exports__